var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0701 18.4306H1.85138C0.792791 18.4306 0.0388844 17.3994 0.363103 16.3915L1.64826 12.3759C2.06232 11.0869 3.47248 10.4189 4.73029 10.9072C5.56623 11.2314 6.64045 11.4853 7.95685 11.4853C9.12482 11.4853 10.1014 11.2861 10.8944 11.0126C11.0194 11.8954 11.4217 12.7509 12.1014 13.4267C12.8787 14.204 13.9061 14.6454 15.0037 14.6767L15.5545 16.3915C15.8787 17.3994 15.1287 18.4306 14.0701 18.4306Z",
    fill: "#C4D8FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 9.98535C10.1852 9.98535 11.9883 8.18225 11.9883 5.95801C11.9883 3.73377 10.1852 1.93066 7.96094 1.93066C5.7367 1.93066 3.93359 3.73377 3.93359 5.95801C3.93359 8.18225 5.7367 9.98535 7.96094 9.98535Z",
    fill: "#C4D8FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5078 13.8018L18.0391 12.333C18.9375 10.9775 18.7891 9.12988 17.5977 7.93848C16.2344 6.5752 14.0195 6.5752 12.6602 7.93848C11.2969 9.30176 11.2969 11.5166 12.6602 12.876C13.8555 14.0713 15.7031 14.2158 17.0586 13.3174L18.5273 14.7861C18.7969 15.0557 19.2383 15.0557 19.5078 14.7861C19.7773 14.5166 19.7773 14.0752 19.5078 13.8018ZM13.6367 11.8955C12.8164 11.0752 12.8164 9.74316 13.6367 8.91894C14.457 8.09473 15.7891 8.09863 16.6133 8.91894C17.4375 9.73926 17.4336 11.0713 16.6133 11.8916C15.793 12.7158 14.4609 12.7158 13.6367 11.8955Z",
    fill: "#C4D8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitIcon);
export default __webpack_public_path__ + "static/media/recruitIcon.bcf222c52cb26672e14dc8fa57a841ab.svg";
export { ForwardRef as ReactComponent };